module.exports = __webpack_public_path__ + "static/media/autopilot-logo.3a287fbe.png";